import React, { useEffect, useState } from "react";
import axiosConfig from "../Service/axiosConfig";
import { PopupModal } from "../Components";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router";
import { NavbarComponent } from "../Components/navbar/NavComponent";
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdCheckCircle, MdDeleteOutline, MdClose } from "react-icons/md";
import { IoMdArrowRoundBack } from "react-icons/io";
import { MarketingNavbarComponent } from "../Components/navbar";
import { BsFillCloudUploadFill } from "react-icons/bs";
import { FileManager } from "../Components/FileManager";

const AccordionSection = ({
    title,
    isOpen,
    onToggle,
    isLocked,
    isCompleted,
    children
}) => {
    return (
        <div className="card mb-3" style={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
            opacity: isLocked ? 0.6 : 1,
            pointerEvents: isLocked ? "none" : "auto",
            overflow: "hidden"
        }}>
            <div
                className="card-header d-flex justify-content-between align-items-center"
                onClick={!isLocked ? onToggle : undefined}
                style={{
                    cursor: isLocked ? "not-allowed" : "pointer",
                    backgroundColor: isOpen ? "#f8f9fa" : "#fff",
                    padding: "1rem 1.5rem",
                    borderBottom: isOpen ? "1px solid #e0e0e0" : "none",
                    transition: "background-color 0.2s"
                }}
            >
                <div className="d-flex align-items-center gap-2">
                    {/* {isCompleted && <MdCheckCircle color="#1b7d78" size={20} />} */}
                    <h5 className="m-0" style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: isLocked ? "#999" : "#333"
                    }}>
                        {title}
                    </h5>
                </div>
                <div>
                    {isOpen ? <MdKeyboardArrowUp size={24} /> : <MdKeyboardArrowDown size={24} />}
                </div>
            </div>

            {isOpen && (
                <div className="card-body p-4" style={{ backgroundColor: "#fff" }}>
                    {children}
                </div>
            )}
        </div>
    );
};

const PromotionalCategoryAdd = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    // UI State
    const [popupType, setpopupType] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [activeSection, setActiveSection] = useState("basic"); // basic, categories, subcategories, products
    const [loading, setLoading] = useState(false);
    const [modalShow, setModalShow] = useState(false);

    // Backend Saved Items State (to track which items are currently persisted on server)
    const [savedCategoryIds, setSavedCategoryIds] = useState([]);
    const [savedSubcategoryIds, setSavedSubcategoryIds] = useState([]);
    const [savedProductIds, setSavedProductIds] = useState([]);

    // Data State
    const [formData, setFormData] = useState({
        title: "",
        slug: "",
        description: "",
        image: null,
        category: [],
        subcategory: [],
        products: []
    });

    // Options State
    const [availableCategories, setAvailableCategories] = useState([]);
    const [availableSubcategories, setAvailableSubcategories] = useState([]);
    const [availableProducts, setAvailableProducts] = useState([]);

    // Logic State
    const [existingSlug, setExistingSlug] = useState(null);
    const [slugManual, setSlugManual] = useState(false);

    // Check if step is completed (simple check based on data presence or id)
    const isBasicCompleted = !!id;
    const isCategoriesCompleted = formData.category.length > 0;
    const isSubcategoriesCompleted = formData.subcategory.length > 0;

    // Fetch initial data
    useEffect(() => {
        // Fetch all categories initially as they are needed for the first step after basic
        const fetchInitialData = async () => {
            try {
                let allCategories = [];
                let nextUrl = `/catlog/categories/?is_promotional_category=false&is_suspended=false`
                while (nextUrl) {
                    const res = await axiosConfig.get(nextUrl);
                    allCategories = [...allCategories, ...(res.data.results ?? [])];
                    nextUrl = res.data.next;
                }

                setAvailableCategories(
                    allCategories.filter(cat => !cat.is_suspended)
                );

            } catch (err) {
                console.error("Error fetching categories:", err);
            }
        };
        fetchInitialData();

        if (id) {
            fetchPromotionalCategoryData();
        }

        if (location.state?.openSection) {
            setActiveSection(location.state.openSection);
        }
    }, [id, location.state]);

    const fetchPromotionalCategoryData = async () => {
        setLoading(true);
        try {
            const res = await axiosConfig.get(`/cms/promotional_category/${id}/`);
            const data = res.data;

            setExistingSlug(data.slug);
            const initialCategories = Array.isArray(data.category)
                ? data.category.map(c => typeof c === "object" ? c.id : c)
                : [];
            const initialSubcategories = Array.isArray(data.subcategory)
                ? data.subcategory.map(s => typeof s === "object" ? s.id : s)
                : [];
            const initialProducts = Array.isArray(data.products)
                ? data.products.map(p => typeof p === "object" ? p.id : p)
                : [];

            setSavedCategoryIds(initialCategories);
            setSavedSubcategoryIds(initialSubcategories);
            setSavedProductIds(initialProducts);

            setFormData({
                title: data.title,
                slug: data.slug,
                description: data.description || "",
                image: data.image || null,
                category: initialCategories,
                subcategory: initialSubcategories,
                products: initialProducts
            });

            if (data.products && Array.isArray(data.products)) {
                setAvailableProducts(prev => {
                    const existingMap = new Map(prev.map(p => [p.id, p]));
                    data.products.forEach(p => {
                        if (typeof p === "object" && !p.is_suspended) existingMap.set(p.id, p);
                    });
                    return Array.from(existingMap.values()).filter(p => !p.is_suspended);
                });
            }

            if (data.category?.length > 0) {
                const categoryIds = data.category.map(c =>
                    typeof c === "object" ? c.id : c
                );
                fetchSubcategories(categoryIds);
            }

            if (data.subcategory?.length > 0) {
                const subIds = data.subcategory.map(s =>
                    typeof s === "object" ? s.id : s
                );
                fetchProducts(subIds);
            }


        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchSubcategories = async (categoryIds) => {
        if (!categoryIds || categoryIds.length === 0) {
            setAvailableSubcategories([]);
            return;
        }
        try {
            let allSubcategories = [];
            let nextUrl = `/catlog/sub-categories/?category=${categoryIds.join(",")}&is_suspended=false`;

            while (nextUrl) {
                const res = await axiosConfig.get(nextUrl);
                allSubcategories = [...allSubcategories, ...(res.data.results ?? [])];
                nextUrl = res.data.next;
            }

            setAvailableSubcategories(allSubcategories.filter(sub => !sub.is_suspended));
        } catch (err) {
            console.error(err);
        }
    };

    const fetchProducts = async (subcategoryIds) => {
        if (!subcategoryIds || subcategoryIds.length === 0) {
            setAvailableProducts([]);
            return;
        }
        let products = []
        let nextUrl = `/catlog/products/?subcategory_id_in=${subcategoryIds.join(",")}&is_suspended=false`
        try {
            while (nextUrl) {
                const res = await axiosConfig.get(nextUrl);
                products = [...products, ...(res.data.results ?? [])]
                nextUrl = res.data.next
            }
            setAvailableProducts(prev => {
                const existingMap = new Map(prev.map(p => [p.id, p]));
                products
                    .filter(p => !p.is_suspended)
                    .forEach(p => existingMap.set(p.id, p));
                return Array.from(existingMap.values()).filter(p => !p.is_suspended);
            });
        } catch (err) {
            console.error(err);
        }
    };

    // --- FORM HANDLERS ---

    const handleBasicChange = (e) => {
        const { name, value } = e.target;

        if (name === "slug") {
            // When typing in slug field, convert spaces to hyphens
            const formattedValue = value.replace(/\s+/g, '-');
            setSlugManual(true);
            setFormData(prev => ({ ...prev, [name]: formattedValue }));
            return;
        }

        if (name === "title" && !slugManual) {
            // Auto-generate slug from title: spaces and special chars to hyphens
            const slug = value.trim().replace(/[\/\s,&]+/g, "-").toLowerCase();
            setFormData(prev => ({ ...prev, [name]: value, slug }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // --- SAVE ACTIONS ---

    const saveBasicDetails = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = new FormData();
        payload.append("title", formData.title);
        payload.append("slug", formData.slug);
        payload.append("description", formData.description);
        if (formData.image?.id) {
            payload.append("image", formData.image.id);
        }
        try {
            let res;
            if (id) {
                res = await axiosConfig.patch(`/cms/promotional_category/${id}/`, payload, { headers: { "Content-Type": "multipart/form-data" } });
                setMessage("Basic Details Updated");
            } else {
                res = await axiosConfig.post(`/cms/promotional_category/`, payload, { headers: { "Content-Type": "multipart/form-data" } });
                setMessage("Promotional Category Created");
                // Navigate to edit mode with the new ID
                navigate(`/dashboard/masters/promotionalcategoryadd/${res.data.id}/edit`, {
                    replace: true,
                    state: { openSection: 'categories' }
                });
            }

            setpopupType("success");
            setActiveSection("categories");
        } catch (error) {
            console.error(error);
            setError(error.response?.data?.error || "Error saving basic details");
            setpopupType("error");
        } finally {
            setLoading(false);
        }
    };

    // --- REMOVE ITEMS API HELPER ---

    const removeItemsAPI = async (itemType, itemIds) => {
        if (!id) return;
        const payload = {
            item_type: itemType, // 'category', 'subcategory', 'product'
            item_ids: Array.isArray(itemIds) ? itemIds : [itemIds]
        };
        return await axiosConfig.post(`/cms/promotional_category/${id}/remove_items/`, payload);
    };

    const removeDirectly = async (type, itemId) => {
        const isSaved = type === "category"
            ? savedCategoryIds.includes(itemId)
            : type === "subcategory"
                ? savedSubcategoryIds.includes(itemId)
                : savedProductIds.includes(itemId);

        if (isSaved && id) {
            setLoading(true);
            try {
                await removeItemsAPI(type, [itemId]);

                if (type === "category") {
                    const updated = formData.category.filter(catId => catId !== itemId);
                    setFormData(prev => ({ ...prev, category: updated }));
                    setSavedCategoryIds(prev => prev.filter(catId => catId !== itemId));
                    fetchSubcategories(updated);
                } else if (type === "subcategory") {
                    const updated = formData.subcategory.filter(subId => subId !== itemId);
                    setFormData(prev => ({ ...prev, subcategory: updated }));
                    setSavedSubcategoryIds(prev => prev.filter(subId => subId !== itemId));
                    fetchProducts(updated);
                } else if (type === "product") {
                    const updated = formData.products.filter(prodId => prodId !== itemId);
                    setFormData(prev => ({ ...prev, products: updated }));
                    setSavedProductIds(prev => prev.filter(prodId => prodId !== itemId));
                }
            } catch (err) {
                console.error(err);
                setError(err.response?.data?.detail || err.response?.data?.error || `Error removing ${type}`);
                setpopupType("error");
            } finally {
                setLoading(false);
            }
        } else {
            // Not saved on backend or in add mode: remove locally
            if (type === "category") {
                const updated = formData.category.filter(catId => catId !== itemId);
                setFormData(prev => ({ ...prev, category: updated }));
                fetchSubcategories(updated);
            } else if (type === "subcategory") {
                const updated = formData.subcategory.filter(subId => subId !== itemId);
                setFormData(prev => ({ ...prev, subcategory: updated }));
                fetchProducts(updated);
            } else if (type === "product") {
                setFormData(prev => ({
                    ...prev,
                    products: prev.products.filter(prodId => prodId !== itemId)
                }));
            }
        }
    };

    const saveCategories = async () => {
        if (!id) return;
        setLoading(true);

        try {
            // Find any saved categories that were deselected
            const removedCategories = savedCategoryIds.filter(catId => !formData.category.includes(catId));
            if (removedCategories.length > 0) {
                await removeItemsAPI("category", removedCategories);
            }

            const payload = new FormData();
            formData.category.forEach(catId => payload.append("category", catId));
            if (formData.category.length === 0) payload.append("category", "");

            await axiosConfig.patch(`/cms/promotional_category/${id}/`, payload);
            setSavedCategoryIds([...formData.category]);

            setMessage("Categories Saved");
            setpopupType("success");

            // Prepare next step
            await fetchSubcategories(formData.category);
            setActiveSection("subcategories");
        } catch (error) {
            console.error(error);
            setError(error.response?.data?.detail || error.response?.data?.error || "Error saving categories");
            setpopupType("error");
        } finally {
            setLoading(false);
        }
    };

    const saveSubcategories = async () => {
        if (!id) return;
        setLoading(true);

        try {
            // Find any saved subcategories that were deselected
            const removedSubcategories = savedSubcategoryIds.filter(subId => !formData.subcategory.includes(subId));
            if (removedSubcategories.length > 0) {
                await removeItemsAPI("subcategory", removedSubcategories);
            }

            const payload = new FormData();
            formData.subcategory.forEach(subId => payload.append("subcategory", subId));
            if (formData.subcategory.length === 0) payload.append("subcategory", "");

            await axiosConfig.patch(`/cms/promotional_category/${id}/`, payload);
            setSavedSubcategoryIds([...formData.subcategory]);

            setMessage("Subcategories Saved");
            setpopupType("success");

            // Prepare next step
            await fetchProducts(formData.subcategory);
            setActiveSection("products");
        } catch (error) {
            console.error(error);
            setError(error.response?.data?.detail || error.response?.data?.error || "Error saving subcategories");
            setpopupType("error");
        } finally {
            setLoading(false);
        }
    };

    const saveProducts = async () => {
        if (!id) return;
        setLoading(true);

        try {
            // Find any saved products that were deselected
            const removedProducts = savedProductIds.filter(prodId => !formData.products.includes(prodId));
            if (removedProducts.length > 0) {
                await removeItemsAPI("product", removedProducts);
            }

            const payload = new FormData();
            formData.products.forEach(prodId => payload.append("products", prodId));
            if (formData.products.length === 0) payload.append("products", "");

            await axiosConfig.patch(`/cms/promotional_category/${id}/`, payload);
            setSavedProductIds([...formData.products]);

            setMessage("Products Saved Successfully");
            setpopupType("success");
            setActiveSection(null);
        } catch (error) {
            console.error(error);
            setError(error.response?.data?.detail || error.response?.data?.error || "Error saving products");
            setpopupType("error");
        } finally {
            setLoading(false);
        }
    };

    // --- RENDER HELPERS ---

    const handleMultiCheckboxChange = (e, listName, itemId) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            setFormData(prev => ({
                ...prev,
                [listName]: [...prev[listName], itemId]
            }));
        } else {
            // Directly remove on uncheck
            removeDirectly(listName, itemId);
        }
    };


    return (
        <div className="child-sidenav">
            <MarketingNavbarComponent />
            <div className="childnav-content">
                <div className="container-fluid mt-4" style={{ maxWidth: "1200px" }}>

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 style={{ color: "#5C5C5C", fontWeight: "600" }}>
                            {id ? "Edit Promotional Category" : "Add Promotional Category"}
                        </h4>
                        <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                            <span><IoMdArrowRoundBack /></span> Back
                        </button>
                    </div>

                    {/* SECTION 1: BASIC DETAILS */}
                    <AccordionSection
                        title="Basic Details"
                        isOpen={activeSection === 'basic'}
                        // onToggle={() => setActiveSection('basic')} always open
                        onToggle={() =>
                            setActiveSection(activeSection === 'basic' ? null : 'basic')
                        }

                        isLocked={false}
                        isCompleted={isBasicCompleted}
                    >
                        <form onSubmit={saveBasicDetails}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">Title <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleBasicChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Slug <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="slug"
                                        value={formData.slug}
                                        onChange={handleBasicChange}
                                        required
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleBasicChange}
                                        rows="3"
                                    />
                                </div>
                                <div>
                                    <label className="form-label">Image <span className="text-danger">*</span></label>
                                    <div className="image-field">
                                        <label
                                            className="image-container"
                                            onClick={() => setModalShow(true)}
                                        >
                                            {formData.image ? (
                                                <img
                                                    className="image"
                                                    src={formData.image.image}
                                                    alt="selected"
                                                />
                                            ) : (
                                                <div className="image-icon">
                                                    <BsFillCloudUploadFill className="upload-icon" />
                                                    <p className="textfile">Choose a file</p>
                                                </div>
                                            )}
                                        </label>
                                    </div>

                                </div>
                                <div className="col-12 text-end mt-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? "Saving..." : (id ? "Update Basic Details" : "Create & Continue")}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </AccordionSection>

                    {/* SECTION 2: CATEGORIES */}
                    <AccordionSection
                        title="Categories"
                        isOpen={activeSection === 'categories'}
                        onToggle={() =>
                            setActiveSection(activeSection === 'categories' ? null : 'categories')
                        }
                        isLocked={!id}
                        isCompleted={isCategoriesCompleted}
                    >
                        <div className="row">
                            {formData.category.length > 0 && (
                                <div className="col-12 mb-3">
                                    <label className="form-label fw-bold small text-muted">
                                        Selected Categories ({formData.category.length}):
                                    </label>
                                    <div className="d-flex flex-wrap gap-2">
                                        {formData.category.map(catId => {
                                            const cat = availableCategories.find(c => c.id === catId);
                                            const catName = cat ? cat.name : `Category #${catId}`;
                                            const isSaved = savedCategoryIds.includes(catId);
                                            return (
                                                <span
                                                    key={catId}
                                                    className="badge d-inline-flex align-items-center gap-1 px-2 py-2"
                                                    style={{
                                                        backgroundColor: isSaved ? "#e6f4f1" : "#f3f4f6",
                                                        color: isSaved ? "#1b7d78" : "#374151",
                                                        border: isSaved ? "1px solid #1b7d78" : "1px solid #d1d5db",
                                                        borderRadius: "6px",
                                                        fontSize: "13px"
                                                    }}
                                                >
                                                    {catName}
                                                    <MdClose
                                                        style={{ cursor: "pointer", marginLeft: "4px" }}
                                                        size={16}
                                                        title="Remove"
                                                        onClick={() => removeDirectly("category", catId)}
                                                    />
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            <div className="col-12 mb-2">
                                <label className="form-label small text-muted">Available Categories:</label>
                            </div>
                            {availableCategories.map(cat => (
                                <div className="col-md-3 col-sm-6 mb-2" key={cat.id}>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`cat-${cat.id}`}
                                            checked={formData.category.includes(cat.id)}
                                            onChange={(e) => handleMultiCheckboxChange(e, 'category', cat.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`cat-${cat.id}`}>
                                            {cat.name}
                                        </label>
                                    </div>
                                </div>
                            ))}
                            <div className="col-12 text-end mt-3 pt-3 border-top">
                                <button
                                    className="btn btn-primary"
                                    onClick={saveCategories}
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Save Categories & Continue"}
                                </button>
                            </div>
                        </div>
                    </AccordionSection>

                    {/* SECTION 3: SUBCATEGORIES */}
                    <AccordionSection
                        title="Subcategories"
                        isOpen={activeSection === 'subcategories'}
                        onToggle={() =>
                            setActiveSection(activeSection === 'subcategories' ? null : 'subcategories')
                        }
                        isLocked={!isCategoriesCompleted || !id} // Need categories first
                        isCompleted={isSubcategoriesCompleted}
                    >
                        <div className="row">
                            {formData.subcategory.length > 0 && (
                                <div className="col-12 mb-3">
                                    <label className="form-label fw-bold small text-muted">
                                        Selected Subcategories ({formData.subcategory.length}):
                                    </label>
                                    <div className="d-flex flex-wrap gap-2">
                                        {formData.subcategory.map(subId => {
                                            const sub = availableSubcategories.find(s => s.id === subId);
                                            const subName = sub ? sub.name : `Subcategory #${subId}`;
                                            const isSaved = savedSubcategoryIds.includes(subId);
                                            return (
                                                <span
                                                    key={subId}
                                                    className="badge d-inline-flex align-items-center gap-1 px-2 py-2"
                                                    style={{
                                                        backgroundColor: isSaved ? "#e6f4f1" : "#f3f4f6",
                                                        color: isSaved ? "#1b7d78" : "#374151",
                                                        border: isSaved ? "1px solid #1b7d78" : "1px solid #d1d5db",
                                                        borderRadius: "6px",
                                                        fontSize: "13px"
                                                    }}
                                                >
                                                    {subName}
                                                    <MdClose
                                                        style={{ cursor: "pointer", marginLeft: "4px" }}
                                                        size={16}
                                                        title="Remove"
                                                        onClick={() => removeDirectly("subcategory", subId)}
                                                    />
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            <div className="col-12 mb-2">
                                <label className="form-label small text-muted">Available Subcategories:</label>
                            </div>
                            {availableSubcategories.length > 0 ? (
                                availableSubcategories.map(sub => (
                                    <div className="col-md-3 col-sm-6 mb-2" key={sub.id}>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`sub-${sub.id}`}
                                                checked={formData.subcategory.includes(sub.id)}
                                                onChange={(e) => handleMultiCheckboxChange(e, 'subcategory', sub.id)}
                                            />
                                            <label className="form-check-label" htmlFor={`sub-${sub.id}`}>
                                                {sub.name}
                                            </label>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center text-muted py-3">
                                    No subcategories available. Please select Categories first and Save.
                                </div>
                            )}
                            <div className="col-12 text-end mt-3 pt-3 border-top">
                                <button
                                    className="btn btn-primary"
                                    onClick={saveSubcategories}
                                    disabled={loading || availableSubcategories.length === 0}
                                >
                                    {loading ? "Saving..." : "Save Subcategories & Continue"}
                                </button>
                            </div>
                        </div>
                    </AccordionSection>

                    {/* SECTION 4: PRODUCTS */}
                    <AccordionSection
                        title="Products"
                        isOpen={activeSection === 'products'}
                        onToggle={() =>
                            setActiveSection(activeSection === 'products' ? null : 'products')
                        }
                        isLocked={!isSubcategoriesCompleted || !id}
                        isCompleted={formData.products.length > 0}
                    >
                        <div className="row">
                            <div className="col-12">
                                <label className="form-label">Select Products</label>
                                <Select
                                    isMulti
                                    options={availableProducts.filter(p => !p.is_suspended).map(p => ({ value: p.id, label: p.name }))}
                                    value={availableProducts
                                        .filter(p => !p.is_suspended && formData.products.includes(p.id))
                                        .map(p => ({ value: p.id, label: p.name }))
                                    }
                                    onChange={(selected) => {
                                        const newValues = selected ? selected.map(opt => opt.value) : [];
                                        const removed = formData.products.filter(pId => !newValues.includes(pId));
                                        if (removed.length > 0) {
                                            removed.forEach(pId => removeDirectly("product", pId));
                                        } else {
                                            setFormData(prev => ({ ...prev, products: newValues }));
                                        }
                                    }}
                                    placeholder="Search and select products..."
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    menuPortalTarget={document.body}   // 🔥 Important
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })  // 🔥 Important
                                    }}
                                />
                            </div>

                            {/* Assigned / Selected Products List */}
                            {formData.products.length > 0 && (
                                <div className="col-12 mt-4">
                                    <label className="form-label fw-bold small text-muted">
                                        Assigned Products ({formData.products.filter(prodId => {
                                            const prod = availableProducts.find(p => p.id === prodId);
                                            return prod ? !prod.is_suspended : true;
                                        }).length}):
                                    </label>
                                    <div className="table-responsive" style={{ maxHeight: "350px", overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: "8px" }}>
                                        <table className="table table-hover align-middle mb-0" style={{ fontSize: "14px" }}>
                                            <thead style={{ backgroundColor: "#f9fafb", position: "sticky", top: 0, zIndex: 1 }}>
                                                <tr>
                                                    <th style={{ width: "60px", padding: "12px 16px" }}>#</th>
                                                    <th style={{ padding: "12px 16px" }}>Product Name</th>
                                                    <th style={{ width: "120px", padding: "12px 16px", textAlign: "end" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.products
                                                    .filter(prodId => {
                                                        const prod = availableProducts.find(p => p.id === prodId);
                                                        return prod ? !prod.is_suspended : true;
                                                    })
                                                    .map((prodId, idx) => {
                                                        const prod = availableProducts.find(p => p.id === prodId);
                                                        const prodName = prod ? prod.name : `Product #${prodId}`;
                                                        return (
                                                            <tr key={prodId}>
                                                                <td style={{ padding: "10px 16px" }}>{idx + 1}</td>
                                                                <td style={{ padding: "10px 16px", fontWeight: "500" }}>{prodName}</td>
                                                                <td style={{ padding: "10px 16px", textAlign: "end" }}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1"
                                                                        onClick={() => removeDirectly("product", prodId)}
                                                                    >
                                                                        <MdDeleteOutline size={16} /> Remove
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            <div className="col-12 text-end mt-3 pt-3 border-top">
                                <button
                                    className="btn btn-primary"
                                    onClick={saveProducts}
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Save Products"}
                                </button>
                            </div>
                        </div>
                    </AccordionSection>

                </div>
            </div>

            {popupType !== "" && (
                <PopupModal
                    setpopupType={setpopupType}
                    popupType={popupType}
                    Message={message}
                    error={error}
                />
            )}
            {modalShow && (
                <FileManager
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    handleFile={(files) => {
                        if (files?.length) {
                            setFormData(prev => ({
                                ...prev,
                                image: files[0]
                            }));
                        }
                    }}
                    ismultiple={false}
                />
            )}

        </div>
    );
};

export default PromotionalCategoryAdd;